var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup954(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(-2555 -53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18V18H0Z",
    transform: "translate(2573 71) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "_369356",
    "data-name": 369356,
    transform: "translate(2555.845 53.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M8.461,16.923a8.461,8.461,0,1,1,8.461-8.461A8.461,8.461,0,0,1,8.461,16.923ZM7.027,9.968l-1.507.162a3.076,3.076,0,0,0,.8,1.762,2.69,2.69,0,0,0,1.625.746v1.052h.838V12.608a2.792,2.792,0,0,0,1.761-.882,2.582,2.582,0,0,0,.632-1.762,2.312,2.312,0,0,0-.5-1.534,3.74,3.74,0,0,0-1.891-.974V5.2a1.179,1.179,0,0,1,.694.925l1.463-.191a2.438,2.438,0,0,0-.694-1.385A2.5,2.5,0,0,0,8.778,3.92V3.35H7.942v.573a2.418,2.418,0,0,0-1.592.742,2.262,2.262,0,0,0-.6,1.593A2.471,2.471,0,0,0,6.28,7.85a3.211,3.211,0,0,0,1.662.974v2.418a1.586,1.586,0,0,1-.567-.484,1.934,1.934,0,0,1-.347-.8Zm1.752,1.365h0V9.078a1.451,1.451,0,0,1,.748.43,1.027,1.027,0,0,1,.228.667,1.136,1.136,0,0,1-.272.754,1.182,1.182,0,0,1-.7.4Zm-.836-4.15h0a1.287,1.287,0,0,1-.558-.424A.967.967,0,0,1,7.2,6.19a1.023,1.023,0,0,1,.2-.613,1.088,1.088,0,0,1,.543-.393v2Z",
    transform: "translate(-0.307 -0.307)",
    fill: "#5b7891"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup954);
export default __webpack_public_path__ + "static/media/Group 954.5a1b15a7cf2708dc245fed7b43c99c5d.svg";
export { ForwardRef as ReactComponent };